import { render, staticRenderFns } from "./OrderFulfillmentTypeDialog.vue?vue&type=template&id=19768483&"
import script from "./OrderFulfillmentTypeDialog.vue?vue&type=script&lang=js&"
export * from "./OrderFulfillmentTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports